import { graphql } from "react-relay";

export const DeleteJobMutation = graphql`
  mutation DeleteJobMutation($input: DeleteJobInput!) {
    deleteJob(input: $input) {
      success
    }
  }
`;